<my-checkbox>
    <input 
        type="checkbox" 
        checked="{ state.checked }" 
        value="{ props.value }" 
        onchange="{
                    handleChange
                }" 
        />

    <script>
        import eventBus from '/src/utils/event-bus'
        import { EVENTS } from '/src/utils/constants'

        export default {

            onBeforeMount(props, state) {
                this.state = {
                    checked: props.checked ?? false
                }
                eventBus.on(EVENTS.CHECKBOX.RESET, this.handleResetCheckbox)
            },

            onBeforeUnmount(props, state) {
                eventBus.off(EVENTS.CHECKBOX.RESET, this.handleResetCheckbox)
            },

            handleResetCheckbox(e) {
                if (e.ckey === this.props.ckey) {
                    this.update({
                        checked: false
                    })
                    this.$("input").checked = false
                }
            },

            handleChange(e) {
                const checked = e.target.checked
                // Trigger eventi per comunicare la modifica al genitore
                if (this.props.value === '*') {
                    eventBus.trigger(EVENTS.CHECKBOX.CHECK_ALL, {
                        ckey: this.props.ckey,
                        checked: checked
                    });
                } else {
                    eventBus.trigger(EVENTS.CHECKBOX.CHECK, {
                        ckey: this.props.ckey,
                        value: this.props.value,
                        checked: checked
                    });
                }
            }
        };
    </script>
</my-checkbox>
